<template>
    <div class="ml-5 mr-5 mt-5" id="WaiverCreate">
        <v-stepper v-model="step" non-linear @reload="reloadstep($event)">
            <v-stepper-header>
                <v-stepper-step :complete="step > 1" step="1" :editable="action === actions.EDIT">{{ $t("page.createWaiver.step_1")
                    }}</v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step :complete="step > 2" step="2" :editable="action === actions.EDIT">{{ $t("page.createWaiver.step_2")
                    }}</v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step :complete="step > 3" step="3" :editable="action === actions.EDIT">{{ $t("page.createWaiver.step_3")
                    }}</v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step :complete="step > 4" step="4" :editable="action === actions.EDIT">{{ $t("page.createWaiver.step_4")
                    }}</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-row>
                        <v-col cols="12">
                            <h3>{{ $t("page.createWaiver.title_step_1") }}</h3>
                        </v-col>
                        <v-col cols="12" sm="10" md="8" class="mx-auto">
                            <v-row>
                                <v-col cols="12">
                                    <v-form ref="formWaiver">
                                        <v-row>
                                            <v-col cols="12" sm="10" md="6">
                                                <v-text-field 
                                                    :label="$t('page.createWaiver.waiver_reference_name')" 
                                                    v-model="waiverName" 
                                                    outlined dense
                                                    :hint="$t('page.createWaiver.description_1_step_1')"
                                                    persistent-hint
                                                    :rules="waiverNameRules"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="10" md="6">
                                                <v-select
                                                    :items="ageItems"
                                                    :label="$t('page.createWaiver.age_target')" 
                                                    v-model="ageTarget" 
                                                    outlined dense
                                                    :hint="$t('page.createWaiver.description_2_step_1')"
                                                    persistent-hint
                                                    :rules="ageTargetRules"
                                                    :no-data-text="$t('common.no_data')"
                                                ></v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="10" md="6">
                                                <v-checkbox v-model="isPictureRequired" :label="$t(
                                                    'page.createWaiver.picture_required'
                                                )
                                                    " :hint="$t(
                                                        'page.createWaiver.picture_description'
                                                    )
                                                        " persistent-hint></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-col>
                            </v-row>
                            <br />
                        </v-col>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="12" class="d-block d-sm-flex btn-group my-2">
                                    <v-btn color="primary" v-if="step > 1" @click="step--"
                                        class="ml-2 my-1 float-left float-sm-none">{{ $t("common.back") }}</v-btn>
                                    <v-btn color="primary" v-if="step == 1"
                                        class="ml-2 my-1 ml-sm-auto btn-group float-left float-sm-none"
                                        @click="goBack">{{ $t("common.cancel") }}</v-btn>
                                    <v-btn color="primary" v-if="action === actions.EDIT" :class="`${action === actions.EDIT
                                            ? 'ml-2 my-1 btn-group'
                                            : 'ml-2 my-1 ml-sm-auto'
                                        } float-left float-sm-none`" @click="submit">{{
                                            $t("common.save_and_close")
                                        }}</v-btn>
                                    <v-btn color="primary" :class="`${action === actions.EDIT
                                            ? 'ml-2 my-1 btn-group'
                                            : 'ml-2 my-1'
                                        } float-left float-sm-none`" @click="goLogo">{{ $t("common.next") }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                <v-stepper-content step="2">
                    <v-row>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="12" class="d-block d-sm-flex btn-group my-2">
                                    <v-btn color="primary" @click="step--" class="ml-2 my-1 float-left float-sm-none">{{
                                        $t("common.back") }}</v-btn>
                                    <v-btn color="primary"
                                        class="ml-2 my-1 ml-sm-auto btn-group float-left float-sm-none"
                                        @click="goBack">{{ $t("common.cancel") }}</v-btn>
                                    <v-btn color="primary" v-if="action === actions.EDIT" :class="`${action === actions.EDIT
                                            ? 'ml-2 my-1 btn-group'
                                            : 'ml-2 my-1 ml-sm-auto'
                                        } float-left float-sm-none`" @click="submit">{{
                                            $t("common.save_and_close")
                                        }}</v-btn>
                                    <v-btn color="primary" :class="`${action === actions.EDIT
                                            ? 'ml-2 my-1 btn-group'
                                            : 'ml-2 my-1'
                                        } float-left float-sm-none`" @click="goStep3">{{ $t("common.next") }}</v-btn>
                                </v-col>
                            </v-row>
                            <br />
                        </v-col>
                        <v-col cols="12" sm="10" md="8" class="mx-auto">
                            <v-row>
                                <v-col cols="12">
                                    <h3>
                                        {{
                                            $t("page.createWaiver.title_step_2")
                                        }}
                                    </h3>
                                    <h5>
                                        {{
                                            $t(
                                                "page.createWaiver.subtitle_step_2"
                                            )
                                        }}
                                    </h5>
                                    <p class="mt-4">
                                        {{
                                            $t(
                                                "page.createWaiver.description_1_step_2"
                                            )
                                        }}
                                    </p>
                                    <v-tabs class="mt-4" v-model="tab">
                                        <v-tab v-for="(language, i) in languages" :key="i" :href="`#${language.code}`">
                                            {{ language.text }}
                                        </v-tab>
                                    </v-tabs>
                                    <v-tabs-items v-model="tab">
                                        <v-tab-item v-for="(language, j) in languages" :key="j" :value="language.code">
                                            <v-card>
                                                <v-card-text>
                                                    <FormWaiver :ref="'formWaiver' +
                                                        language.code
                                                        " :language="language.code
                                                            " @showSnackBar="
                                                            showSnackBar
                                                        " @loadDataParent="
                                                            loadData
                                                        " @onImageChange="
                                                            onWaiverImageChange
                                                        " :bandEditParent="action === actions.EDIT
                                                            " />
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                    </v-tabs-items>
                                </v-col>
                            </v-row>
                            <br />
                        </v-col>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="12" class="d-block d-sm-flex btn-group my-2">
                                    <v-btn color="primary" @click="step--" class="ml-2 my-1 float-left float-sm-none">{{
                                        $t("common.back") }}</v-btn>
                                    <v-btn color="primary"
                                        class="ml-2 my-1 ml-sm-auto btn-group float-left float-sm-none"
                                        @click="goBack">{{ $t("common.cancel") }}</v-btn>
                                    <v-btn color="primary" v-if="action === actions.EDIT" :class="`${action === actions.EDIT
                                            ? 'ml-2 my-1 btn-group'
                                            : 'ml-2 my-1 ml-sm-auto'
                                        } float-left float-sm-none`" @click="submit">{{
                                            $t("common.save_and_close")
                                        }}</v-btn>
                                    <v-btn color="primary" :class="`${action === actions.EDIT
                                            ? 'ml-2 my-1 btn-group'
                                            : 'ml-2 my-1'
                                        } float-left float-sm-none`" @click="goStep3">{{ $t("common.next") }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                <v-stepper-content step="3">
                    <v-row>
                        <v-col cols="12" class="mx-auto">
                            <v-row>
                                <v-col cols="12" class="d-block d-sm-flex btn-group my-2">
                                    <v-btn color="primary" @click="step--" class="ml-2 my-1 float-left float-sm-none">{{
                                        $t("common.back") }}</v-btn>
                                    <v-btn color="primary"
                                        class="ml-2 my-1 ml-sm-auto btn-group float-left float-sm-none"
                                        @click="goBack">{{ $t("common.cancel") }}</v-btn>
                                    <v-btn color="primary" v-if="enabledSaveStep3 || action === actions.EDIT" :class="`${enabledSaveStep3 || action === actions.EDIT
                                            ? 'ml-2 my-1 btn-group'
                                            : 'ml-2 my-1 ml-sm-auto'
                                        } float-left float-sm-none`" @click="submit">{{
                                            $t("common.save_and_close")
                                        }}</v-btn>
                                    <v-btn color="primary" :class="`${enabledSaveStep3 || action === actions.EDIT
                                            ? 'ml-2 my-1 btn-group'
                                            : 'ml-2 my-1'
                                        } float-left float-sm-none`" @click="goInformation">{{ $t("common.next")
                                        }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <br />
                    <v-row>
                        <v-col cols="12" sm="10" md="8" class="mx-auto">
                            <v-row>
                                <v-col cols="12">
                                    <h3>
                                        {{
                                            $t("page.createWaiver.title_step_4")
                                        }}
                                    </h3>
                                    <p class="ml-6">
                                        {{
                                            $t(
                                                "page.createWaiver.description_1_step_4"
                                            )
                                        }}
                                    </p>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="11" class="mx-auto">
                            <v-data-table 
                                v-model="selectedEvents" 
                                :headers="headerEvents" 
                                :search="search"
                                :items="events" 
                                dense 
                                item-key="id" 
                                show-select 
                                :footer-props="{
                                    'items-per-page-options': [ 10, 20, 30, 50, -1 ],
                                    'items-per-page-text': $t('dataTable.rowsPerPageText'),
                                    'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                                }" 
                                :items-per-page="50" 
                                :no-data-text="$t('dataTable.noDataText')"
                                :headerProps="{
                                    'sort-by-text': $t('dataTable.sortByText')
                                }"
                                :no-results-text="$t('dataTable.no_matching_records')"
                            >
                                <template v-slot:item.displayFlagText="{ item }">
                                    {{ item.displayFlag ? $t("dashboard.menu.eventDetails.yes") : $t("dashboard.menu.eventDetails.no") }}
                                </template>
                                <template v-slot:item.displayRegistrationFlagText="{ item }">
                                    {{ item.displayRegistrationFlag ? $t("dashboard.menu.eventDetails.yes") : $t("dashboard.menu.eventDetails.no") }}
                                </template>
                            </v-data-table>
                            <br>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="mx-auto">
                            <v-row>
                                <v-col cols="12" class="d-block d-sm-flex btn-group my-2">
                                    <v-btn color="primary" @click="step--" class="ml-2 my-1 float-left float-sm-none">{{
                                        $t("common.back") }}</v-btn>
                                    <v-btn color="primary"
                                        class="ml-2 my-1 ml-sm-auto btn-group float-left float-sm-none"
                                        @click="goBack">{{ $t("common.cancel") }}</v-btn>
                                    <v-btn color="primary" v-if="enabledSaveStep3 || action === actions.EDIT" :class="`${enabledSaveStep3 || action === actions.EDIT
                                            ? 'ml-2 my-1 btn-group'
                                            : 'ml-2 my-1 ml-sm-auto'
                                        } float-left float-sm-none`" @click="submit">{{
                                            $t("common.save_and_close")
                                        }}</v-btn>
                                    <v-btn color="primary" :class="`${enabledSaveStep3 || action === actions.EDIT
                                            ? 'ml-2 my-1 btn-group'
                                            : 'ml-2 my-1'
                                        } float-left float-sm-none`" @click="goInformation">{{ $t("common.next")
                                        }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                <v-stepper-content step="4">
                    <v-row>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="12" class="d-block d-sm-flex btn-group my-2">
                                    <v-btn color="primary" @click="step--" class="ml-2 my-1 float-left float-sm-none">{{
                                        $t("common.back") }}</v-btn>
                                    <v-btn color="primary"
                                        class="ml-2 my-1 ml-sm-auto btn-group float-left float-sm-none"
                                        @click="goBack">{{ $t("common.cancel") }}</v-btn>
                                    <v-btn color="primary" class="ml-2 my-1 float-left float-sm-none" @click="submit">{{
                                        $t("common.save_and_close")
                                    }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="10" md="8" class="mx-auto">
                            <br />
                            <v-row>
                                <v-col cols="12">
                                    <h3>
                                        {{
                                            $t("page.createWaiver.title_step_5")
                                        }}
                                    </h3>
                                    <p class="">
                                        {{
                                            $t(
                                                "page.createWaiver.description_1_step_5"
                                            )
                                        }}
                                    </p>
                                    <v-form ref="formWaiverType">
                                        <v-row no-gutters>
                                            <v-col cols="12" class="my-0 py-0">
                                                <v-checkbox v-model="participantType" :label="$t('common.participant')
                                                    " class="mt-0" :rules="participantTypeRules
                                                        "></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" class="my-0 py-0">
                                                <v-checkbox v-model="spectatorType" :label="$t('common.spectator')
                                                    " class="mt-0" :rules="spectatorTypeRules"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
        <v-snackbar v-model="snack" :color="color_snack">{{
            msg_snack
            }}</v-snackbar>
    </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import FormWaiver from "@/components/waivers/FormWaiver";
import axios from "axios";
const patternAlphanumeric = /^[0-9a-zA-Z ]+$/;

export default {
    components: { FormWaiver },
    mixins: [apiCalls],
    props: ["step3"],
    data() {
        return {
            buttonColor: "#000",
            msg_snack: "",
            snack: false,
            color_snack: "success",
            step: 1,
            waiverName: "",
            ageTarget: "",
            languagesResponse: [],
            tab: "",
            selectedEvents: [],
            events: [],
            search: "",
            participantType: false,
            spectatorType: false,
            userCurrent: null,
            waiversContentEdit: [],
            isPictureRequired: false,
            isWaiverImageChanged: new Set(),
            actions: {
                EDIT: 'WaiverEdit',
                CREATE: 'WaiverCreate'
            }
        };
    },
    methods: {
        onWaiverImageChange(languageCode) {
            this.isWaiverImageChanged.add(languageCode);
        },
        async getAvailable() {
            const response = await this.getApi("/api/v1/langs/available");
            /*this.languages = response.map((item) => {
                return {
                    id: item.id,
                    code: item.languageCode,
                    text: this.$t("page.createWaiver." + item.languageCode),
                };
            });*/
            this.languagesResponse = response;
        },
        async getEvents() {
            const response = await this.api(
                "get",
                "/api/v1/promoter/waivers/getEvents"
            );

            for (var i = 0; i < response.message.length; i++) {
                response.message[i].displayFlagText =
                    response.message[i].displayFlag == 1
                        ? this.$t("dashboard.menu.eventDetails.yes")
                        : this.$t("dashboard.menu.eventDetails.no");

                response.message[i].displayRegistrationFlagText =
                    response.message[i].displayRegistrationFlag == 1
                        ? this.$t("dashboard.menu.eventDetails.yes")
                        : this.$t("dashboard.menu.eventDetails.no");
            }
            this.events = response.message.map((el) => {
                return {
                    ...el,
                    nameId: `${this.$escapeHtml.decode(el.name)} - ${el.id}`,
                };
            });
        },
        goLogo() {
            if (!this.$refs.formWaiver.validate()) {
                this.showSnackBar(
                    this.$t("page.createWaiver.waiver_information_required")
                );
                return;
            }
            this.step++;
        },
        async getUser() {
            const getUserCurrent = await this.api(
                "get",
                "/api/v1/users/current"
            );
            this.userCurrent = getUserCurrent.message;
        },
        goEvent() {
            this.step++;
        },
        goInformation() {
            if (this.selectedEvents.length == 0) {
                this.showSnackBar(this.$t("page.createWaiver.events_empty"));
                return;
            }
            this.step++;
        },
        goBack() {
            this.$router.push({ name: "CloneWaiversOld" });
        },
        showSnackBar(message, color = "error") {
            this.msg_snack = message;
            this.color_snack = color;
            this.snack = true;
        },
        goStep3() {
            let hasIncompleteTranslation = false;
            let hasValidTranslation = false;
            let incompleteLanguage = "";

            for (const language of this.languages) {
                const formRef = this.$refs[`formWaiver${language.code}`];

                if (formRef) {
                    const isValid = formRef[0].verifyValidation();
                    if (isValid) {
                        hasValidTranslation = true;
                    } else if (!hasValidTranslation) {
                        hasIncompleteTranslation = true;
                        const form = formRef[0];
                        if (
                            incompleteLanguage == "" ||
                            (form.waiverTitle || "").length > 0 ||
                            (form.waiver || "").length > 0 ||
                            (form.electronicSignature || "").length > 0
                        ) {
                            incompleteLanguage = language;
                        }
                    }
                } else {
                    if (this.action === this.actions.EDIT) {
                        const waiverTranslate = this.waiversContentEdit.find(
                            (item1) => item1.languageCode == language.code
                        );
                        if (
                            !waiverTranslate ||
                            (waiverTranslate &&
                                ((waiverTranslate.title || "").length == 0 ||
                                    (waiverTranslate.waiverText || "").length == 0 ||
                                    (waiverTranslate.waiverElectronicConsent || "").length == 0))
                        ) {
                            hasIncompleteTranslation = true;
                            if (incompleteLanguage == "") {
                                incompleteLanguage = language;
                            }
                        } else {
                            hasValidTranslation = true;
                        }
                    } else {
                        hasIncompleteTranslation = true;
                        if (incompleteLanguage == "") {
                            incompleteLanguage = language;
                        }
                    }
                }
            }

            if (!hasValidTranslation) {
                if (hasIncompleteTranslation) {
                    this.showSnackBar(
                        this.$t("page.createWaiver.waiver_content_required", {
                            language: incompleteLanguage.text,
                        })
                    );
                } else {
                    this.showSnackBar(
                        this.$t("page.createWaiver.waiver_content_required_global")
                    );
                }
                this.tab = incompleteLanguage.code;
                return;
            }
            
            this.step++;
        },
        async submit() {
            const validateWaiverType = () => {
                if (this.action !== this.actions.EDIT &&
                    !this.enabledSaveStep3 &&
                    !this.$refs.formWaiverType.validate()
                ) {
                    this.showSnackBar(this.$t("page.createWaiver.waiver_type_required"));
                    return false;
                }
                return true;
            };

            if (!validateWaiverType()) return;

            if (this.action === this.actions.EDIT) {
                if (!this.$refs.formWaiver.validate()) {
                    this.step = 1;
                    this.showSnackBar(
                        this.$t("page.createWaiver.waiver_information_required")
                    );
                    return;
                }
                let hasValidTranslation = false;
                let languageItem = null;
                this.languages.forEach((item) => {
                    const form = this.$refs[`formWaiver${item.code}`];
                    if (form) {
                        hasValidTranslation = true;
                    } else {
                        const waiverTranslate = this.waiversContentEdit.find(
                            item1 => item1.languageCode === item.code
                        );

                        const isValidWaiverTranslate = waiverTranslate &&
                            waiverTranslate.title?.length > 0 &&
                            waiverTranslate.waiverText?.length > 0 &&
                            waiverTranslate.waiverElectronicConsent?.length > 0;

                        if (isValidWaiverTranslate) {
                            hasValidTranslation = true;
                        } else if (!languageItem) {
                            languageItem = item;
                        }
                    }
                });
                if (!hasValidTranslation) {
                    this.step = 2;
                    this.tab = languageItem.code;
                    this.showSnackBar(
                        this.$t("page.createWaiver.waiver_content_required", {
                            language: languageItem.text,
                        })
                    );
                    return;
                }
                if (
                    !this.enabledSaveStep3 &&
                    !this.$refs.formWaiverType.validate()
                ) {
                    this.step = 4;
                    this.showSnackBar(
                        this.$t("page.createWaiver.waiver_type_required")
                    );
                    return;
                }
            }
            this.$store.commit('TOGGLE_OVERLAY', true);
            let waiverContent = [],
                selectedEventsC = [];
            this.events.forEach((item) => {
                item.isDeleted = true;
                this.selectedEvents.forEach((item2) => {
                    if (item.id == item2.id) {
                        item.isDeleted = false;
                    }
                });
                selectedEventsC.push(item);
            });
            let data = {
                promoterId: this.userCurrent.id,
                name: this.waiverName,
                ageTarget: this.ageTarget,
                waiverContent,
                events: selectedEventsC,
                participantType: this.participantType,
                spectatorType: this.spectatorType,
                isPictureRequired: !!this.isPictureRequired,
            };
            if (this.action === this.actions.EDIT) data.id = this.$route.params.id;
            let waiverTraslate = null;
            let contWaiverTranslateCompleted = 0;
            let BreakException = {};
            try {
                this.languages.forEach((item) => {
                    const element = this.$refs[`formWaiver${item.code}`]
                        ? this.$refs[`formWaiver${item.code}`][0]
                        : undefined;
                    waiverTraslate = null;
                    let _item = null;
                    if (element && element.verifyValidation()) {
                        _item = {
                            language: item,
                            waiverTitle: element.waiverTitle,
                            waiver: element.waiver,
                            electronicSignature: element.electronicSignature,
                        };
                        contWaiverTranslateCompleted++;
                    } else if (this.action === this.actions.EDIT) {
                        let waiverTitle = element ? element.waiverTitle : "";
                        let waiver = element ? element.waiver : "";
                        let electronicSignature = element
                            ? element.electronicSignature
                            : "";
                        let bandFormIncompleted =
                            (waiverTitle || "").length > 0 ||
                            (waiver || "").length > 0 ||
                            (electronicSignature || "").length > 0;

                        if (
                            element &&
                            !element.verifyValidation() &&
                            (contWaiverTranslateCompleted == 0 ||
                                (contWaiverTranslateCompleted > 0 &&
                                    bandFormIncompleted))
                        ) {
                            BreakException = item;
                            throw BreakException;
                        } else if (
                            this.waiversContentEdit &&
                            this.waiversContentEdit.length > 0
                        ) {
                            if (!element) {
                                waiverTraslate = this.waiversContentEdit.find(
                                    (item1) => item1.languageCode === item.code
                                );
                                if (waiverTraslate) {
                                    _item = {
                                        language: item,
                                        waiverTitle: waiverTraslate.title,
                                        waiver: waiverTraslate.waiverText,
                                        electronicSignature:
                                            waiverTraslate.waiverElectronicConsent,
                                    };
                                    if (this.action === this.actions.EDIT)
                                        _item.id = waiverTraslate.id;
                                }
                            }
                        }
                    }
                    if (this.action === this.actions.EDIT) {
                        waiverTraslate = this.waiversContentEdit.find(
                            (item1) => item1.languageCode == item.code
                        );
                        if (_item && waiverTraslate)
                            _item.id = waiverTraslate.id;
                        if (_item && !waiverTraslate) _item.id = item.code;
                    }
                    if (_item) waiverContent.push(_item);
                });
            } catch (e) {
                this.$store.commit('TOGGLE_OVERLAY', false);
                this.showSnackBar(
                    this.$t("page.createWaiver.warning_language", {
                        language: e.text,
                    })
                );
                return;
            }

            data.waiverContent = waiverContent;
            let response = null;
            if (this.action === this.actions.EDIT)
                response = await this.putApi(
                    "/api/v1/promoter/waivers/edit/" + this.$route.params.id,
                    data
                );
            else
                response = await this.postApi(
                    "/api/v1/promoter/waivers/create",
                    data
                );
            if (response.success) { //console.log('response: ',response);
                this.showSnackBar(this.$t("common.success"), "success");
                this.uploadImage(response.message);
            } else {
                this.$store.commit('TOGGLE_OVERLAY', false);
                this.showSnackBar(this.$t("common.failed-save"));
                return;
            }

            this.color_snack = "success";
            this.msg_snack = this.$t("common.success");
            this.snack = true;
            this.uploadImage(response.message);

            setTimeout(() => {
                this.goBack();
            }, 1000);
        },
        uploadImage(id) {
            let imageUpload = []; 
            const imagesUploaded = this.languages.filter((item) => this.isWaiverImageChanged.has(item.code));
            if((imagesUploaded || []).length > 0){
                imagesUploaded.forEach((item) => {
                    const data = new FormData();
                    const element = this.$refs[`formWaiver${item.code}`]
                        ? this.$refs[`formWaiver${item.code}`][0]
                        : undefined;
                    if (
                        element &&
                        Object.prototype.hasOwnProperty.call(
                            element,
                            "uploadImage_"
                        )
                    ) {
                        data.append("image", element.uploadImage_);
                        data.append("fileName", element.fileName);
                        data.append("language", item.id);
                        let axiosConfig = {
                            headers: { "content-type": "multipart/form-data" },
                        };

                        axios
                            .put(
                                `${this.root}/laravel/public/api/v1/promoter/waivers/picture/${id}`,
                                data,
                                axiosConfig
                            )
                            .then((response) => {
                                if (!response.data.success) {
                                    this.showSnackBar(
                                        this.$t(
                                            "page.createWaiver.file_upload_failed",
                                            {
                                                language: this.$t(
                                                    "page.createWaiver." +
                                                    item.code
                                                ),
                                            }
                                        )
                                    );
                                } else {
                                    imageUpload.push(item.code);
                                    if (
                                        imageUpload.length == this.languages.length
                                    ) {
                                        setTimeout(() => {
                                            this.$router.push({
                                                name: "CloneWaiversOld",
                                            });
                                        }, 500);
                                    }
                                }
                            })
                            .catch(
                                function (error) {
                                    const status = error.response.status;

                                    switch (status) {
                                        case 401:
                                            window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
                                            break;
                                    }
                                }.bind(this)
                            );
                    } else {
                        imageUpload.push(item.code);
                        if (imageUpload.length == this.languages.length) {
                            setTimeout(() => {
                                this.$router.push({ name: "CloneWaiversOld" });
                            }, 500);
                        }
                    }
                });
            } else {
                setTimeout(() => {
                    this.$router.push({ name: "CloneWaiversOld" });
                }, 500);
            }
        },
        async getWaiver(id) {
            const response = await this.api(
                "get",
                "/api/v1/promoter/waivers/getEventWaiver/" + id
            );

            for (var i = 0; i < response.message.eventWaivers.length; i++) {
                response.message.eventWaivers[i].displayFlagText =
                    response.message.eventWaivers[i].displayFlag == 1
                        ? this.$t("dashboard.menu.eventDetails.yes")
                        : this.$t("dashboard.menu.eventDetails.no");

                response.message.eventWaivers[i].displayRegistrationFlagText =
                    response.message.eventWaivers[i].displayRegistrationFlag ==
                        1
                        ? this.$t("dashboard.menu.eventDetails.yes")
                        : this.$t("dashboard.menu.eventDetails.no");
            }
            this.events = response.message.eventWaivers.map((el) => {
                return {
                    ...el,
                    nameId: `${this.$escapeHtml.decode(el.name)} - ${el.id}`,
                };
            });

            if (response.success) {
                this.waiverName = response.message.name;
                this.ageTarget = response.message.ageTarget;
                this.waiversContentEdit = response.message.waiversContent;
                const types = response.message.waiverType.split(",");
                this.participantType = !!types.find(
                    (item) => item == "Participant"
                );
                this.spectatorType = !!types.find(
                    (item) => item == "Spectator"
                );
                this.isPictureRequired = !!response.message.isPictureRequired;
                const eventWaivers = response.message.eventWaivers;
                if (eventWaivers.length > 0) {
                    this.selectedEvents = this.events.filter((item) => {
                        return item.eventWaiver == true;
                    });
                }
                this.waiversContentEdit.forEach((el) => {
                    if (this.$refs[`formWaiver${el.languageCode}`]) {
                        this.$refs[`formWaiver${el.languageCode}`][0].loadData(
                            el
                        );
                    }
                });
            }
        },
        loadData(language) {
            const waiverTraslate = this.waiversContentEdit.find((el) => {
                return el.languageCode == language;
            });
            if (waiverTraslate) {
                this.$refs[`formWaiver${language}`][0].loadData(waiverTraslate);
            }
        },
    },
    computed: {
        ageItems() {
            return [
                { value: "Adult", text: this.$t("common.adult") },
                { value: "Minor", text: this.$t("common.minor") },
            ];
        },
        waiverNameRules() {
            return [
                (val) =>
                    (val || "").length > 0 ||
                    this.$t("page.createWaiver.waiver_name_required"),
                (val) =>
                    !!val.match(patternAlphanumeric) ||
                    this.$t("page.createWaiver.waiver_name_invalid"),
            ];
        },
        ageTargetRules() {
            return [
                (val) =>
                    (val || "").length > 0 ||
                    this.$t("page.createWaiver.age_target_required"),
            ];
        },
        headerEvents() {
            return [
                {
                    text: this.$t("page.createWaiver.event_name"),
                    align: "start",
                    sortable: true,
                    value: "nameId",
                },
                {
                    text: this.$t("page.createWaiver.registration_open"),
                    value: "registrationOpen",
                    sortable: true,
                },
                {
                    text: this.$t("page.createWaiver.registration_close"),
                    value: "registrationClose",
                    sortable: true,
                },
                {
                    text: this.$t("page.createWaiver.event_date"),
                    value: "eventDate",
                    sortable: true,
                },
                {
                    text: this.$t("page.createWaiver.display_event_online"),
                    value: "displayFlagText",
                    sortable: true,
                    align: "center",
                },
                {
                    text: this.$t(
                        "page.createWaiver.display_registration_online"
                    ),
                    value: "displayRegistrationFlagText",
                    sortable: true,
                    align: "center",
                },
            ];
        },
        participantTypeRules() {
            return [
                (val) => {
                    if (!val && !this.spectatorType)
                        return this.$t(
                            "page.createWaiver.option_type_required"
                        );
                    return true;
                },
            ];
        },
        spectatorTypeRules() {
            return [
                (val) => {
                    if (!val && !this.participantType)
                        return this.$t(
                            "page.createWaiver.option_type_required"
                        );
                    return true;
                },
            ];
        },
        enabledSaveStep3() {
            return this.selectedEvents.length == 0;
        },
        action() {
            return this.$route.name;
        },
        languages() {
            return this.languagesResponse.map((item) => {
                return {id: item.id, code: item.languageCode, text: this.$t("page.createWaiver." + item.languageCode)};
            });
        }
    },
    created: function () {
        this.buttonColor = process.env.VUE_APP_BUTTON_COLOR;
        this.getUser();
    },
    mounted() {
        this.getAvailable();

        if (this.action === this.actions.EDIT) {
            this.getWaiver(this.$route.params.id);
        } else {
            this.getEvents();
        }

        if (this.$route.params.step3) this.step = this.$route.params.step3;
    },
    watch: {
        participantType(val) {
            if (val) {
                this.$refs.formWaiverType.validate();
            }
        },
        spectatorType(val) {
            if (val) {
                this.$refs.formWaiverType.validate();
            }
        },
        step(val) {
            if (val == 2) {
                this.waiversContentEdit.forEach((el) => {
                    if (this.$refs[`formWaiver${el.languageCode}`]) {
                        this.$refs[`formWaiver${el.languageCode}`][0].loadData(
                            el
                        );
                    }
                });
            }
        },
    },
};
</script>

<style>
.mr-auto {
    border: 1px solid #d0d0d0;
}

@media (max-width: 460px) {
    .v-application .d-flex {
        display: block !important;
    }

    .btn-group {
        display: block !important;
    }
}
</style>
